import angular from "angular"
import "../authentication/authentication"
import "../analysis/analysis"
import "../configParams/configParams"
import "../r2BackgroundTaskJob/r2BackgroundTaskJob"
import "../bi/bi"
import "../header/header"
import "../job/job"
import "../script/script"
import "../search/search"
import "../carrier-zone/carrier-zone"
import "../productCategory/productCategory"
import "../product/product"
import "../locality/locality"
import "../session-records/sessionRecords"
import "../unblockTripMessages/unblockTripMessages"
import "../unreleaseTripMessages/unreleaseTripMessages"
import "../unblockCancelTripMessages/unblockCancelTripMessages"
import "../driver/driver"
import "../vehicle/vehicle"
import "../home/home"
import "../panel/panel"
import "../report/report"
import "../restrictions/restrictions"
import "../order/order"
import "../orderType/orderType"
import "../help/help"
import "../routeStopPopup/routeStopPopup"
import "../cancellation/cancellation"
import "../about/about"
import "../optimization/optimization"
import "../authorization/authorization"
import "../classification/classification"
import "../generic-attribute/genericAttribute"
import "../generic-param-definition/genericParamDefinition"
import "../load-unload-duration/loadUnloadDuration"
import "../message/messageConfigParams"
import "../vehicle-availability/availability"
import "../integration/integration"
import "../userByOrigins/userByOrigins"
import "../allowedOrigins/allowedOrigins"
import "../truckAllocation/truckAllocation"
import "../lgpd/lgpd"
import "../invoice/invoice"
import "../automatic-optimization/automaticOptimization"
import "../transitions-config/transitionsConfig"
import "../analysisMap/analysisMap"
import "../query/query"
import "front-end-web-commons"
import "monitoring"
import "angular-sanitize"
import "usermanagement"
import "nlg-tracking"
import "gateway"
import "../notification/notification"
import "../menu/r2Menu"
import "../units/units"
import "./supply/supply"
import "../tenant/tenant.ts"

export default angular.module("r2", [
    "nlgPageTitleModule",
    "ngSanitize",
    // Módulos r2
    "authentication",
    "analysisModule",
    "configParamsModule",
    "headerModule",
    "jobModule",
    "menuModule",
    "menuCommonsModule",
    "productCategoryModule",
    "productModule",
    "localityModule",
    "sessionRecordsModule",
    "unblockTripMessagesModule",
    "unreleaseTripMessagesModule",
    "unblockCancelTripMessagesModule",
    "driverModule",
    "vehicleModule",
    "homeModule",
    "biModule",
    "r2BackgroundTaskJobModule",
    "r2PanelModule",
    "carrierZoneModule",
    "orderModule",
    "orderTypeModule",
    "helpModule",
    "routeStopPopupModule",
    "cancellationModule",
    "aboutModule",
    "optimizationModule",
    "reportModule",
    "scriptModule",
    "searchModule",
    "authorizationModule",
    "classificationModule",
    "genericAttributeModule",
    "genericParamDefinitionModule",
    "loadUnloadDurationModule",
    "availabilityModule",
    "integrationModule",
    "allowedOriginsModule",
    "userByOriginsModule",
    "truckAllocationModule",
    "lgpdModule",
    "invoiceModule",
    "automaticOptimizationModule",
    "transitionsConfigModule",
    "analysisMapModule",
    "notificationModule",
    "r2MenuModule",
    "unitsModule",
    "supplyModule",
    "tenantModule",

    // Módulos globais de front-end-web-commons
    "panelModule",
    "nlgTagInputModule",
    "restrictionsModule",
    "nlgNumberInputModule",
    "uiBootstrapModule",
    "menuModule",
    "nlgPermissionModule",
    "nlgSelectionModule",
    "userManagementModule",
    "nlgNavigateModule",
    "trackingModule",
    "monitoringModule",
    "trackingMobileModule",
    "monitorModule",
    "nlgHealthCheckerModule",
    "messageConfigParamsModule",
    "queryModule",
    "microstrategyModule",
    "gatewayModule",
    "toastModule",
    "userPreferencesModule",
    "nlgPasswordModule"

])